<script>
import playground from "../../../mixins/playground/playground";
import Response from "./ResultadoApi.vue";
import numeroProcesso from "../../../mixins/playground/numeroProcesso";

export default {
  name: "StatusAtualizacaoProcesso",
  mixins:[playground, numeroProcesso],
  components: { Response },
  computed: {
    colunas() {
      return [
        { key: "numeroCnj", label: "Número CNJ", isVisible: true },
        { key: "status", label: "Status", isVisible: true },
        { key: "criadoEm", label: "Criado em", isVisible: true },
        { key: "dataUltimaVerificacao", label: "Ultima verificação", isVisible: true },
        { key: "tempoDesdeUltimaVerificacao", label: "Tempo desde a ultima verificacao", isVisible: false },
        { key: "concluidoEm", label: "Concluido em", isVisible: false },
      ]
    }
  },
}
</script>

<template>
  <div>
    <form id="form-playground-status-atualizacao" class="form-playground" @submit.prevent="consultar">
      <div class="space-y-2">
        <label for="numero_cnj2" class="font-medium text-sm">Número CNJ</label>
        <input
          id="numero_cnj"
          name="numero_cnj"
          v-model="numero"
          class="input is-large px-2 rounded-md block"
          type="text"
          v-mask="'#######-##.####.#.##.####'"
          placeholder="0000000-00.0000.0.00.0000"
          autofocus="autofocus"
        />
      </div>
    </form>

    <div class="custo">
      <slot name="custo"></slot>
    </div>

    <Btn
      class="btn playground-button consultar-button"
      type="button"
      :loading="$wait.is(`fetching_${this.identificador}`)"
      :disabled="$wait.is(`fetching_${this.identificador}`) || inputInvalido"
      @click="consultar"
    >
      <p class="m-0 font-semibold">Consultar</p>
    </Btn>


    <Response
      v-if="response"
      :responseApi="response"
      :identificador="identificador"
      :key="identificador"
      :logIds="logIds"
      :lista-formatada="itens"
      :colunas="colunas"
      :tipos-download="['json']"
    >
    </Response>
  </div>
</template>

<style scoped lang="stylus">
.custo
  width 18.5rem

  @media (max-width: 768px)
    width 100%

.form-playground
  display flex
  flex-direction column
  gap 15px

.form-playground .input
  width 18.5rem

  @media (max-width: 768px)
    width 100%

.playground-button
  background-color #2393ae
  color #fff
  font-size 12px
  border-radius 5px

.playground-button > .Btn__contentBox
  font-weight 600

.playground-button:hover
  opacity 0.8

.consultar-button
  padding 20px 40px
</style>
